<template>
<div>
  <el-dialog title="添加国际套餐" :visible.sync="show" width="1300px" top="5vh" append-to-body :show-close="false">
    <el-form :model="form" ref="form" :rules="rules" label-width="120px">
      <el-form-item label="代理商:" prop="userId" >
          <el-cascader style="width: 50%"
              v-if="!baseId"
              placeholder="代理商"
              ref="myCascader"
              :options="agentTree"
              :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
              :show-all-levels="false"
              clearable
              v-model="form.userId"
              filterable></el-cascader>
            <el-input v-show="!!baseId" v-model="form.company" disabled  style="width: 50%"></el-input>
        </el-form-item>
        <el-form-item label="国际套餐:" prop="productId" >
          <el-select :disabled="!!baseId" v-model="form.productId" filterable placeholder="请选择国际套餐" @change="handleSelectProduct" style="width: 50%">
            <el-option v-for="item in products" :key="item.id" :label="item.id+'-' + item.productName + '-' +item.validityTime +'天'" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国际运营商" prop="operator" v-if="showAdmin">
          <el-tooltip content="批量设置底价和售价" placement="top">
                <i class="el-icon-question"></i>
          </el-tooltip>
          <el-select v-model="type" style="width:130px;margin-right:10px">
            <el-option value="1" label="底价"></el-option>
            <el-option value="2" label="售价"></el-option>
          </el-select>
          <el-input v-model="currentyPrice" placeholder="设置价格" style="width:130px"
            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
          </el-input>
          <el-button type="primary" @click="handleUpdatePrice()" style="margin-left: 10px">设置价格</el-button>
          <el-button type="success" @click="handleUpdateCountry()" style="margin-left: 10px">设置区域</el-button>
        </el-form-item>
        <el-form-item>
          <div class="form-item-operator">
            <el-table ref="currencyTable" :data="form.countryPrices"  row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
              <el-table-column prop="name" label="使用区域" align="center" width="100"></el-table-column>
              <el-table-column prop="countryNames" label="区域限制国家" align="center" width="160">
                <template slot-scope="{row}">
                  <div class="product-list" v-if="row.countryNames && row.countryNames.length > 0">
                    <div class="product-item" v-for="(item,index) in row.countryNames.slice(0, 1)" :key="index" :title="item">
                          <span>{{item}}</span>
                    </div>
                    <span class="el-dropdown-link" v-if="row.countryNames.length>1" @click="showMoreCountry(row)">
                      <i class="el-icon-d-arrow-right el-icon--right"></i>更多
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="currency" label="支付币种" align="center" width="160" v-if="showAdmin">
                <template #header>
                  <div>
                    <el-tooltip content="可以使用货币购买此套餐" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                    <span>支付币种</span>
                  </div>
                </template>
                <template #default="{ row }">
                <el-select
                  v-model="row.currency"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择货币代码"
                  style="width: 140px"
                  @change="handleCurrencyChange(row)"
                >
                  <el-option
                    v-for="item in currencyList"
                    :key="item.id"
                    :label="item.name + '[' + item.currency + ']'"
                    :value="item.currency"
                  ></el-option>
                </el-select>
              </template>
              </el-table-column>
              <el-table-column prop="exchangeRateCny" label="汇率（货币符号）" align="center" width="130" v-if="showAdmin">
                <template #default="{row}">
                  {{row.exchangeRateCny || '无'}}（{{row.currencySymbol || '无'}}）
                </template>
              </el-table-column>
              <el-table-column prop="costPrice" v-if="!showAdmin" label="成本价" align="center" width="80"></el-table-column>
              <el-table-column prop="basePrice" label="底价" align="center" min-width="200">
                <span  slot="header">
                    <el-tooltip content="底价代理商默认的底价价格" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                      底价
                </span>
                <template #default={row}>
                  <el-input style="width: 140px;"  v-model="row.basePrice"
                   :disabled="form.self"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                    <template slot="append">{{row.currencySymbol}}</template>
                    </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="售价" align="center" min-width="200">
                <span  slot="header">
                    <el-tooltip content="比例代理商H5展示价格" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                      售价
                </span>
                <template #default={row}>
                  <el-input style="width: 140px;"  v-model="row.price"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                    <template slot="append">{{row.currencySymbol}}</template>
                    </el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" v-if="showAdmin">
                <template #default="{ row }">
                  <template v-if="row.leaf" >
                    <i class="el-icon-remove-outline" @click="removeCurrencyRow(row)" style="font-size:25px;color: #ff4949"></i>
                  </template>
                  <template v-else>
                    <i class="el-icon-remove-outline" @click="removeParentCurrencyRow(row)" style="font-size:25px;color: #ff4949;margin-left:10px"></i>
                    <i class="el-icon-circle-plus-outline" @click="addCurrencyRow('currencyTable',row)" style="font-size:25px;color: #1890ff;margin-left:10px"></i>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="updateShow">取 消</el-button>
    </div>
  </el-dialog>
  <el-dialog title="设置使用区域" :visible.sync="nextOperatorOpen" width="1300px"  :modal-append-to-body="true" :close-on-click-modal="false" :destroy-on-close="true" @close="closeOperator">
    <el-form  :inline="true" label-width="68px">
      <div style="display: flex; justify-content: space-between; width: 100%;">
        <div style="flex: 1; text-align: left;">
          <el-form-item prop="countryName">
            <el-input v-model="keyword"  placeholder="区域名称" clearable style="width: 210px"/>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="dialog-operator">
      <el-table ref="treeTable" :data="countryGroupData" @selection-change="handleSelectionChange" :row-class-name="hideCheckbox" row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column type="selection" align="center" width="60px"></el-table-column>
        <el-table-column prop="name" label="使用区域" align="center"></el-table-column>
        <el-table-column prop="countryNames" label="区域限制国家" align="center">
          <template slot-scope="{row}">
            <div class="product-list" v-if="row.countryNames && row.countryNames.length > 0">
              <div class="product-item" v-for="(item,index) in row.countryNames.slice(0, 8)" :key="index" :title="item">
                    <span>{{item}}</span>
              </div>
              <span class="el-dropdown-link" v-if="row.countryNames.length>8" @click="showMoreCountry(row)">
                <i class="el-icon-d-arrow-right el-icon--right"></i>更多
              </span>
            </div>
          </template>
        </el-table-column>
        
      </el-table>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="confirmCountry" type="primary" plain>确认添加</el-button>
    </div>
  </el-dialog>

  <el-dialog title="国家列表" :visible.sync="moreCountryOpen" width="600px" append-to-body :close-on-click-modal="false">
      <el-input placeholder="请输入内容" v-model="searchQuery" clearable style="width: 30%"></el-input>
       <div class="tag-container">
        <el-tag
          v-for="item in filteredTableData"
          :key="item"
          type="success"
          class="custom-tag"
        >
          {{ item }}
        </el-tag>
      </div>
    </el-dialog>
</div>
</template>

<script>
import { currencyList } from "@/api/config.js"
import {agentTreeList, selectProductList} from "@/api/api.js"; //新建套餐代理商
import { selectGroupChannel, addBaseInternationalProduct, updateBaseInternationalProduct , baseInternationalProductInfo , baseParentInternationalProductInfo} from "@/api/international.js";
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    //主键id
    baseId:{
      type: String,
      required: false
    }
  },
  data() {
    return {
      // 代理商
      agentTree: [],
      products:[],
      currentyPrice:"",
      type:"1",
      // 查询参数
      form: {
        userId:undefined,
        productId:undefined,
        self:false,
        countryPrices:[]
      },
      rules: {
        userId: [
          { required: true, message: "代理商不能为空", trigger: "blur" },
        ],
        productId: [
          { required: true, message: "国际套餐不能为空", trigger: "blur" }
        ],
        
      },
      currencyList:[],
      multipleSelectionCountry:[],
      nextOperatorOpen:false,
      keyword:'',
      countryGroupData:[],
      originalCountryGroupData:[],
      moreCountryOpen:false,
      searchQuery:'',
      moreCountryData:[],
      searchCountryData:[]
    };
  },
  watch: {
    keyword(newVal, oldVal) {
      this.filteredCountryGroupData()
    }
  },
  computed: {
    showAdmin(){
        return this.$store.getters.user.userType =='1'; 
    },
    filteredTableData() {
      return this.moreCountryData.filter(row => {
        return Object.values(row).some(value => {
          return String(value).toLowerCase().includes(this.searchQuery.toLowerCase());
        });
      });
    },
  },
  methods: {
    updateShow(){
      this.$emit('update-show', false);
    },
    //代理商列表
    handleAgentTreeList(){
      agentTreeList({commissionModel:"1"}).then(res => {
        this.agentTree = res.data.data;
      });
    },
    selectProducts() {
      selectProductList({type:'3'}).then(res => {
        this.products = res.data.data;
      });
    },
    handleSelectProduct(productId){
      if(this.showAdmin){
        //管理员分配套餐  是所有套餐
        
      }else{
        //代理商的底价数据
        baseParentInternationalProductInfo({productId:productId}).then(res=>{
          this.form.countryPrices = res.data.data.countryPrices;
        })
      }
      
    },
    handleUpdatePrice(){
      const basePrice = Number(this.currentyPrice);
      if (!isNaN(basePrice) && basePrice > 0) {
        this.form.countryPrices.forEach(item => {
          const exchangeRate = Number(item.exchangeRateCny);
          if(this.type == '1'){
            if (!isNaN(exchangeRate) && exchangeRate > 0){
              this.$set(item, 'basePrice', basePrice * exchangeRate);
            }
            let children = item.children || [];
            children.forEach(child=>{
              const childExchangeRate = Number(child.exchangeRateCny);
              if (!isNaN(childExchangeRate) && childExchangeRate > 0){
                this.$set(child, 'basePrice', this.currentyPrice * childExchangeRate);
              }
            })
          }else{
            if (!isNaN(exchangeRate) && exchangeRate > 0){
              this.$set(item, 'price', basePrice * exchangeRate);
            }
            let children = item.children || [];
            children.forEach(child=>{
              const childExchangeRate = Number(child.exchangeRateCny);
              if (!isNaN(childExchangeRate) && childExchangeRate > 0){
                this.$set(child, 'price', this.currentyPrice * childExchangeRate);
              }
            })
          }
          
        });
        
      }
      
    },
    submitForm(){
      this.$refs.form.validate(valid => {
        if (valid) {
          if(!!this.baseId){
            updateBaseInternationalProduct(this.form).then(res=>{
              this.updateShow()
              this.$message.success("修改套餐成功");
              this.$router.push({ path: `/package/internationalBasePackage` });
            })
          }else{
            addBaseInternationalProduct(this.form).then(res=>{
              this.updateShow()
              this.$message.success("添加套餐成功");
              this.$router.push({ path: `/package/internationalBasePackage` });
            })
          }
          
        }
      });
    },
    handleUpdateCountry(){
      this.nextOperatorOpen = true;
      this.keyword = '';
      let channel = 'cmlink'
      this.countryGroupData = []
      selectGroupChannel({channel}).then(res=>{
        let  countryData = res.data.data
        countryData.forEach(item=>{
          item.price = 0;
        })
        this.originalCountryGroupData = countryData
        this.filteredCountryGroupData()
      })
    },
    hideCheckbox({ row, rowIndex }) {
      // 根据条件决定是否隐藏复选框
      if (row.leaf) {
        return 'hide-checkbox';
      }
      return '';
    },
    getCurrencyList(){
      currencyList().then(res=>{
        this.currencyList = res.data.data
      })
    },
    filteredCountryGroupData() {
      // 保存当前选中的ID
      const selectedIds = this.multipleSelectionCountry.map(item => item.id);
      
      if (!this.keyword) {
        this.countryGroupData = this.originalCountryGroupData
      } else {
        const query = this.keyword.toLowerCase();
        this.countryGroupData = this.originalCountryGroupData.filter(item => {
          return item.name.toLowerCase().includes(query);
        });
      }
      
      // 在下一个DOM更新周期后恢复选中状态
      this.$nextTick(() => {
        if (this.$refs.treeTable) {
          // 先清空所有选中
          this.$refs.treeTable.clearSelection();
          // 重新选中之前选中的项
          this.countryGroupData.forEach(item => {
            if (selectedIds.includes(item.id)) {
              this.$refs.treeTable.toggleRowSelection(item, true);
            }
          });
        }
      });
    },
    // 监听选中变化，确保multipleSelectionCountry始终包含所有选中的项
    handleSelectionChange(select) {
      // 获取当前搜索结果中所有行的ID
      const currentPageIds = new Set(this.countryGroupData.map(item => item.id));
      
      // 保存所有已选中的ID
      const allSelectedIds = new Set(this.multipleSelectionCountry.map(item => item.id));
      
      // 获取当前页面选中的ID
      const currentPageSelectedIds = new Set(select.map(item => item.id));
      
      // 处理当前页面的选择状态
      currentPageIds.forEach(id => {
        if (currentPageSelectedIds.has(id)) {
          // 如果当前页面的行被选中，添加到所有选中ID中
          allSelectedIds.add(id);
        } else {
          // 如果当前页面的行被取消选中，从所有选中ID中移除
          allSelectedIds.delete(id);
        }
      });
      
      // 构建新的选中数组
      const allSelected = [];
      // 从原始数据中查找所有选中的项
      this.originalCountryGroupData.forEach(item => {
        if (allSelectedIds.has(item.id)) {
          allSelected.push(item);
        }
      });
      
      this.multipleSelectionCountry = allSelected;
    },
    handleCurrencyChange(row){
      const selectedCurrency = this.currencyList.find(
        item => item.currency === row.currency
      );
      if (selectedCurrency) {
        row.currencySymbol = selectedCurrency.currencySymbol;
        row.exchangeRateCny = selectedCurrency.exchangeRateCny
        const basePrice = Number(this.currentyPrice);
        if (!isNaN(basePrice) && basePrice > 0) {
          const exchangeRate = Number(row.exchangeRateCny);
          if (!isNaN(exchangeRate) && exchangeRate > 0) {
            const calculatedPrice = (this.currentyPrice * exchangeRate).toFixed(2);
            if(this.type == '1'){
              this.$set(row, 'basePrice', calculatedPrice);
            }else{
              const calculatedPrice = (this.currentyPrice * exchangeRate).toFixed(2);
              this.$set(row, 'price', calculatedPrice);
            }
            
          }
          
        }
      }
    },
    showMoreCountry(item){
      this.moreCountryOpen = true
      this.moreCountryData = item.countryNames
    },
    confirmCountry(){
      this.nextOperatorOpen = false
      let scs = this.form.countryPrices.map(m=>String(m.id))
      let countries = this.multipleSelectionCountry.filter(item=>scs.indexOf(String(item.id)) === -1)
      this.form.countryPrices.push(...countries)
    },
    removeCurrencyRow(row) {
      let data =  this.form.countryPrices
      const parentRow = data.find(item => item.id === row.parentId);
      if(parentRow  && parentRow.children){
        const childIndex = parentRow.children.findIndex(child => child.id === row.id);
        if(childIndex !== -1){
          parentRow.children.splice(childIndex, 1);
        }
      }
    },
    removeParentCurrencyRow(row){
      let data =  this.form.countryPrices
      const parentIndex = data.findIndex(item => item.id === row.id);
      if(parentIndex !== -1){
        data.splice(parentIndex, 1);
      }
    },
    addCurrencyRow(ref,row) {
      if (!row.children) {
        this.$set(row, 'children', []);
      }
      const newRow = {
        id: `${row.id}_${row.children.length + 1}`,
        parentId: row.id,
        name: '',
        englishName: '',
        currency: '',
        currencySymbol: '',
        price: '',
        leaf : true  //标记为叶子节点
      };
      // 将新行添加到当前行的 children 数组中
      row.children.push(newRow);
      this.$nextTick(() => {
        this.$refs[ref].toggleRowExpansion(row, true);
      });
    },
    closeOperator(){
      this.nextOperatorOpen = false;
    },
    initProduct(){
      if(!!this.baseId){
        baseInternationalProductInfo({id:this.baseId}).then(res=>{
          this.form = res.data.data
          this.form.id = this.baseId
        })
      }
    }
  },
  created(){
    this.getCurrencyList()
    this.handleAgentTreeList();
    this.selectProducts();
    this.initProduct();
    
  }
};
</script>
<style scoped lang="less">
::v-deep .hide-checkbox .cell .el-checkbox__input {
  display: none !important;
}
.form-item-operator{
    overflow: auto;
    max-height: 434px;
    border-top: 1px solid #eff1f4;
    border-bottom: 1px solid #eff1f4;
    padding: 0px 10px 11px 27px;
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #8798AF;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
}
.dialog-operator{
    overflow: auto;
    max-height: 434px;
    border-top: 1px solid #eff1f4;
    border-bottom: 1px solid #eff1f4;
    padding: 0px 10px 11px 27px;
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #8798AF;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
}

.product-list{
  display: flex; 
  flex-wrap: wrap;
  width: 600px;
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 80px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; 
    margin: 5px; 
    background: #ecf5ff; 
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
  .el-dropdown-link{
    cursor: pointer;
    color: #409EFF;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    margin: 5px;
    line-height: 30px;
    -ms-flex-line-pack: start;
    align-content: flex-start;

  }
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px; 
  padding-top: 10px; 
  .custom-tag {
    margin: 0; 
  }
}
</style>